import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share';

import {
  DownloadButton,
  TextWithReadMore,
  ConcertDetailedBanner,
  ClipboardBtn
} from '../../../components';

import './next-live-event.scss';
import Countdown, { zeroPad } from 'react-countdown';
import { Link } from 'react-router-dom';

const NextLiveEvent = ({ data, otherData }) => {
  const {
    windowWidth,
    windowHeight,
    customEventData,
    concertProgram,
    pageUrl,
    timezone,
  } = otherData;

  const { concert } = data;

  const { about, program, artists, banner: innerPoster, slug } =
    concert !== null && concert !== undefined ? concert : '';

  const title = data ? data.title : concert && concert.title;

  const desc = data?.desc;
  console.log(data);

  return (
    <>
      <div className='live_page_container nextLiveEvent'>
        {!concert && (
          <div className='live-event'>
            <div className='live-event__counter'>
              <h2 className='counter__title'>
                The Next Live Event will start in:
              </h2>
              <Countdown
                date={new Date(`${data?.start_date?.replace(' ', 'T')}`).toLocaleString('en-US', {
                  timeZone: timezone,
                })}
                renderer={({ days, hours, minutes, seconds, ...props }) => {
                  return (
                    <>
                      <h4 className='date'>
                        <span>
                          {zeroPad(days)}
                          <span className='label'>DD</span>
                        </span>
                        :
                        <span>
                          {zeroPad(hours)}
                          <span className='label'>HH</span>
                        </span>
                        :
                        <span>
                          {zeroPad(minutes)}
                          <span className='label'>MM</span>
                        </span>
                        :
                        <span>
                          {zeroPad(seconds)}
                          <span className='label'>SS</span>
                        </span>
                      </h4>
                    </>
                  );
                }}
              />
            </div>
            <div className='live_page_head'>
              <div>
                <h1 className='live_page_title'>{title && title}</h1>
                {desc && (
                  <p
                    className='pr-md-4 mb-5'
                    dangerouslySetInnerHTML={{ __html: desc }}
                  />
                )}
              </div>
              <div className='concert__section concert__sharing'>
                <h3 className='sharing__title'>SHARE ON:</h3>
                <div className='sharingBtns'>
                  <FacebookShareButton
                    windowWidth={windowWidth}
                    windowHeight={windowHeight}
                    url={pageUrl}
                  >
                    <FacebookIcon />
                  </FacebookShareButton>

                  <TwitterShareButton
                    windowWidth={windowWidth}
                    windowHeight={windowHeight}
                    url={pageUrl}
                  >
                    <TwitterIcon />
                  </TwitterShareButton>

                  <WhatsappShareButton
                    windowWidth={windowWidth}
                    windowHeight={windowHeight}
                    url={pageUrl}
                  >
                    <WhatsappIcon />
                  </WhatsappShareButton>

                  <ClipboardBtn url={pageUrl} btnClass='clipboardBtn' />
                </div>
              </div>
            </div>
          </div>
        )}
        {concert && (
          <div className='concert'>
            <div className='concert-static__hero'>
              <Link to={`/calendar/${slug}`}>
                <div
                  className='concert__banner__img'
                  style={{
                    backgroundImage: `url('${innerPoster && innerPoster}')`,
                  }}
                />
              </Link>
            </div>
            <div className='concert__hero banner'>
              <div className='concert__head' id='concert__head'>
                <div className='concert__detailed__banner'>
                  <ConcertDetailedBanner
                    concertDetails={concert !== null && concert}
                    options={{
                      timezone,
                      showTitle: true,
                      showCountdown: true,
                    }}
                  />
                </div>
              </div>
              <div
                className='concert__banner__img'
                style={{
                  backgroundImage: `url('${innerPoster && innerPoster}')`,
                }}
              />
            </div>
            {!customEventData && (
              <section className='concert__main'>
                <div className='concert__details'>
                  <div className='concert__section concert__sharing'>
                    <h3 className='sharing__title'>SHARE ON:</h3>
                    <div className='sharingBtns'>
                      <FacebookShareButton
                        windowWidth={windowWidth}
                        windowHeight={windowHeight}
                        url={pageUrl}
                      >
                        <FacebookIcon />
                      </FacebookShareButton>

                      <TwitterShareButton
                        windowWidth={windowWidth}
                        windowHeight={windowHeight}
                        url={pageUrl}
                      >
                        <TwitterIcon />
                      </TwitterShareButton>

                      <WhatsappShareButton
                        windowWidth={windowWidth}
                        windowHeight={windowHeight}
                        url={pageUrl}
                      >
                        <WhatsappIcon />
                      </WhatsappShareButton>

                      <ClipboardBtn url={pageUrl} btnClass='clipboardBtn' />
                    </div>
                  </div>

                  {about ? (
                    <div className='concert__section concert__about'>
                      <h2>About</h2>
                      <TextWithReadMore
                        shortText={about}
                        longText={about}
                        textClass='concert__about__text'
                        useLong
                      />
                    </div>
                  ) : (
                    ''
                  )}

                  {program && program.length ? (
                    <div className='concert__section concert__programme'>
                      <h2>Programme</h2>

                      {program.map((prog, i) => (
                        <div key={i} className='prog'>
                          {prog.upcoming ? (
                            <h3 key={i}>Comming Soon...</h3>
                          ) : (
                            <>
                              <h5 className='prog__subtitle__part'>
                                {prog.part}
                              </h5>

                              {prog.data.map((p, i) => (
                                <Fragment key={i}>
                                  <h3 className='prog__composer'>{p.author}</h3>
                                  <h4 className='prog__music'>
                                    {p.performance}
                                  </h4>
                                  {prog.music_parts &&
                                  prog.music_parts.length ? (
                                    <ul>
                                      {prog.music_parts.map((part, i) => (
                                        <li key={i}>{part.name}</li>
                                      ))}
                                    </ul>
                                  ) : (
                                    ''
                                  )}
                                </Fragment>
                              ))}
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    ''
                  )}

                  {artists &&
                    artists.map(
                      (conductor) =>
                        conductor.role === 'conductor' && (
                          <div
                            key={conductor.id}
                            className='concert__section concert__conductor'
                          >
                            <h3
                              dangerouslySetInnerHTML={{
                                __html: `${conductor.name} ${conductor.surname}`,
                              }}
                            />
                            <h4>CONDUCTOR</h4>

                            {conductor.bio !== '' && (
                              <TextWithReadMore
                                shortText={conductor.bio}
                                longText={conductor.bio}
                                textClass='concert__conductor__text'
                              />
                            )}
                          </div>
                        )
                    )}
                  <div className='concert__section concert__soloists'>
                    {artists &&
                      artists.map(
                        (sol, i) =>
                          sol.role === 'soloist' && (
                            <div key={i} className='concert__soloist'>
                              <h3
                                className='sol__name'
                                dangerouslySetInnerHTML={{
                                  __html: `${sol.name} ${sol.surname}`,
                                }}
                              />
                              <TextWithReadMore
                                shortText={sol.bio}
                                longText={sol.bio}
                                textClass='concert__sol__text'
                              />
                            </div>
                          )
                      )}
                  </div>

                  <div className='concert__section concert__orchestras'>
                    {artists &&
                      artists.map(
                        (orc, i) =>
                          orc.role === 'orchestra' && (
                            <div key={i} className='concert__orchestra'>
                              <h3 className='orc__name'>{orc.name}</h3>
                              <TextWithReadMore
                                shortText={orc.bio}
                                longText={orc.bio}
                                textClass='concert__orc__text'
                              />
                            </div>
                          )
                      )}
                  </div>

                  {concertProgram &&
                    Object.keys(concertProgram).length &&
                    concertProgram.url !== '' && (
                      <div className='concert__section concert__download'>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: concertProgram && concertProgram?.label,
                          }}
                        />

                        <DownloadButton
                          downloadUrl={concertProgram && concertProgram?.url}
                          btnTitle='download'
                        />
                      </div>
                    )}
                </div>
              </section>
            )}
          </div>
        )}
      </div>
    </>
  );
};

NextLiveEvent.propTypes = {
  data: PropTypes.object.isRequired,
  otherData: PropTypes.object.isRequired,
};

export default NextLiveEvent;
